// src/constants.js

// API URLs (without the API key part, which we'll handle better)
export const GEO_API_BASE_URL = "https://api.openweathermap.org/geo/1.0/direct";
export const WEATHER_API_BASE_URL = "https://api.openweathermap.org/data/2.5/weather";
export const FORECAST_API_BASE_URL = "https://api.openweathermap.org/data/2.5/forecast";

// BBQ Score Weights — must sum to 1.0
// Humidity removed (was 0.00); remaining weights scaled proportionally to fill 1.0.
export const BBQ_SCORE_WEIGHTS = {
  PRECIPITATION: 0.46,
  TEMPERATURE: 0.26,
  WIND: 0.21,
  CLOUD: 0.07,
};

// You can also add other fixed values here if they appear, e.g., threshold values for scoring
export const TEMP_THRESHOLDS_F = {
    IDEAL_MIN: 60,
    IDEAL_MAX: 85,
    GOOD_MIN: 50,
    GOOD_MAX: 90,
    OK_MIN: 40,
    OK_MAX: 95,
};